import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ApproachService } from 'src/app/services/approach.service';
import { switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import Discussion from 'src/app/interfaces/Discussion';
import { ForumService } from 'src/app/services/forum.service';
import { UserService } from 'src/app/services/user.service';
import { ResourceService } from 'src/app/services/resource.service';
import Resource from 'src/app/interfaces/Resource';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-approaches-single',
  templateUrl: './approaches-single.component.html',
  styleUrls: ['./approaches-single.component.scss'],
})
export class ApproachesSingleComponent implements OnInit, OnDestroy {
  approach;
  subscriptions: Subscription = new Subscription();
  currentUser;
  discussions: Array<Discussion> = [];
  resources: Array<Resource> = [];
  alkalinity = false;
  directCapture = false;

  constructor(
    private route: ActivatedRoute,
    private approachService: ApproachService,
    private userService: UserService,
    private forumService: ForumService,
    private resourceService: ResourceService,
    private analyticsService: AnalyticsService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.approachService.getApproach(params.get('id')).subscribe((data) => {
        this.approach = data;
        if (this.approach.slug === 'alkalinity') this.alkalinity = true;
        if (this.approach.slug === 'co2-removal') this.directCapture = true;
        this.analyticsService.event('approaches_' + this.approach.slug + '_view');

        this.subscriptions.add(
          this.userService.user.subscribe((u) => {
            if (u && u.uid) {
              this.currentUser = u;
              this.forumService.getDiscussionsByApproach(this.approach.slug, 2).subscribe(
                (d) => (this.discussions = d),
                (e) => console.error(e)
              );
              this.resourceService.getResourcesByApproach(this.approach.slug, 2).subscribe(
                (d) => (this.resources = d),
                (e) => console.error(e)
              );
            }
          })
        );
      });
    });
  }

  videoUrl() {
    // return this.sanitizer.bypassSecurityTrustUrl(this.approach.video);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
